<template>
  <v-menu v-if="currentVersion" offset-y light>
    <template #activator="{ on }">
      <v-btn outlined dark v-on="on">
        {{ currentVersion.label }}
        <v-icon right dark>update</v-icon>
      </v-btn>
    </template>

    <v-list light class="mt-1" style="max-height: 300px; overflow: auto;">
      <v-list-item
        v-for="version in versions"
        :key="version.label"
        style="cursor: pointer;"
        @click="changeVersion(version)"
      >
        <v-list-item-title class="text-capitalize" v-text="version.label" />
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vue2-helpers/vuex';
import { checkIfHasChanges, clearCacheKeepAlive, refreshSearchBar } from '@/utils/pwa';

const store = useStore();
const versions = computed(() => store.getters.versions);
const currentVersion = computed(() => store.getters.version);

const changeVersion = version => {
  checkIfHasChanges(() => {
    store.commit('setVersion', version);
    clearCacheKeepAlive();
    refreshSearchBar();
  });
};

</script>

<style lang="scss" rel="stylesheet/scss">
.version-select {
  margin-top: 15px !important;
}
</style>